import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import Carousel from "react-multi-carousel";

const AlbumModal = ({ albumModal, setAlbumModal, images }) => {
	const AuthData = useSelector((state) => state.Auth);

	const responsive = {
		superLargeDesktop: {
			// the naming can be any, depends on you.
			breakpoint: { max: 4000, min: 3000 },
			items: 1,
			slidesToSlide: 1,
		},
		desktopLg: {
			breakpoint: { max: 3000, min: 1300 },
			items: 1,
			slidesToSlide: 1,
		},
		desktop: {
			breakpoint: { max: 1300, min: 1100 },
			items: 1,
			slidesToSlide: 1,
		},
		tablet: {
			breakpoint: { max: 1100, min: 600 },
			items: 1,
			slidesToSlide: 1,
		},
		mobile: {
			breakpoint: { max: 600, min: 0 },
			items: 1,
			slidesToSlide: 1,
		},
	};
	const CustomDot = ({ onClick, ...rest }) => {
		const {
			index,
			active,
			carouselState: { currentSlide, deviceType },
		} = rest;

		return (
			<button
				className={active ? "active" : "inactive"}
				onClick={() => onClick()}>
				<img src={images[index]?.src} alt="Carousel" key={index} />
			</button>
		);
	};
	return (
		<Modal
			isOpen={albumModal}
			toggle={() => setAlbumModal(false)}
			className={`albumModal ${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}>
			<ModalBody>
				<Carousel
					className="pb-3 mb-4"
					swipeable={true}
					draggable={true}
					showDots={true}
					customDot={<CustomDot />}
					responsive={responsive}
					infinite={false}
					autoPlaySpeed={1000}
					keyBoardControl={true}
					customTransition="all .5"
					transitionDuration={500}
					customRightArrow={<CustomRight />}
					customLeftArrow={<CustomLeft />}
					containerClass="carousel-container"
					removeArrowOnDeviceType={[]}
					dotListClass="custom-dot-list-style"
					itemClass="carousel-item-padding-40-px">
					{images?.map((imageSrc, index) => {
						return <img src={imageSrc?.src} alt="Carousel" key={index} />;
					})}
				</Carousel>
			</ModalBody>
		</Modal>
	);
};
const CustomRight = ({ onClick }) => (
	<button onClick={onClick} className="arrow right border-0">
		<i className="fas fa-arrow-circle-right text-primary fa-2x"></i>
	</button>
);
const CustomLeft = ({ onClick }) => (
	<button onClick={onClick} className="arrow left border-0">
		<i className="fas fa-arrow-circle-left text-primary fa-2x"></i>
	</button>
);
export default AlbumModal;
